import { cva } from '@/styled-system/css';

export const propertyCardRootRecipe = cva({
  base: {
    blockSize: 'fit-content', // fix: bug in Safari where PropertyCardPhoto height is incorrect
  },
  variants: {
    appearance: {
      large: {
        blockSize: '100%',
        minWidth: 'PropertyCard.Root.large.min',
        maxWidth: 'PropertyCard.Root.large.max',
      },
      small: {
        'minWidth': 'PropertyCard.Root.small.min',
        'maxWidth': 'PropertyCard.Root.small.max',

        // Give dataArea5 margin when it's below the card body
        '& > [data-c11n-component="PropertyCard.DataArea"]': {
          marginBlockStart: 'PropertyCard.Root.sm.gap.card-toDataArea5',
        },
      },
      horizontal: {
        'minWidth': 'PropertyCard.Root.horizontal.min',
        'maxWidth': 'PropertyCard.Root.horizontal.max',

        // Give dataArea5 margin when it's below the card body
        '& > [data-c11n-component="PropertyCard.DataArea"]': {
          marginBlockStart: 'PropertyCard.Root.horiz.gap.card-toDataArea5',
        },
      },
    },
  },
});
